import {
  Box,
  Divider,
  Grid,
  InputLabel,
  Paper,
  TextField,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { Spinner } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import {
  clearErrors,
  forgotPassword,
  resetPassword,
} from "../../Redux/Actions/Auth";
import { errorNotify, successNotify } from "../../Utils/toast";
import { useStyle } from "./login-style";
import ReactModal from "../../Components/Modal/Modal";
import { validateEmail } from "../../Utils/helper";
import { IoEyeOff, IoEye } from "react-icons/io5";
import "./UserLogin.css";

const ResetPassword = () => {
  const classes = useStyle();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { resettoken } = useParams();

  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [passwordShow, setPasswordShow] = useState(false);
  const [confirmPasswordShow, setConfirmPasswordShow] = useState(false);
  const [forgotOpen, setForgotOpen] = useState(false);
  const [resendVisible, setResendVisible] = useState(false);
  const [forgotEmail, setForgotEmail] = useState("");

  const { loading, error, response } = useSelector(
    (state) => state.resetPassword || {}
  );
  const forgotState = useSelector((state) => state.forgotPassword || {});

  useEffect(() => {
    if (response?.success || response?.message) {
      successNotify(response?.message || "Password reset successfully");
      dispatch({ type: "RESET_PASSWORD_RESET" });
      navigate("/");
    }
  }, [response, dispatch, navigate]);

  useEffect(() => {
    if (error) {
      errorNotify(error);
      dispatch(clearErrors());
      setResendVisible(true);
    }
  }, [error, dispatch]);

  useEffect(() => {
    if (forgotState?.response?.message) {
      successNotify(forgotState.response.message);
      setForgotOpen(false);
      setForgotEmail("");
      dispatch({ type: "FORGOT_PASSWORD_RESET" });
      setResendVisible(false);
    }
    if (forgotState?.error) {
      errorNotify(forgotState.error);
      dispatch(clearErrors());
    }
  }, [forgotState, dispatch]);

  const onSubmit = (e) => {
    e.preventDefault();
    if (!password || !confirmPassword)
      return errorNotify("Please fill in all fields");
    if (password.length < 8)
      return errorNotify("Password must be at least 8 characters");
    if (password !== confirmPassword)
      return errorNotify("Passwords do not match");
    dispatch(resetPassword(resettoken, password));
  };

  const handleForgotSubmit = (e) => {
    e.preventDefault();
    if (!validateEmail(forgotEmail))
      return errorNotify("Please enter a valid email");
    dispatch(forgotPassword(forgotEmail.trim()));
  };

  return (
    <Box className={classes.loginContainer}>
      <Grid
        item
        container
        sx={{ height: "100%", width: "100%" }}
        direction="row"
        justifyContent="flex-end"
        alignItems={"center"}
      >
        <Grid xs={7} item sx={{ mr: 3 }}>
          <Paper className={classes.loginCard}>
            <Box sx={{ width: "80%" }}>
              <Typography
                variant="h5"
                sx={{ fontWeight: "900", fontSize: "28px", color: "#010101" }}
              >
                <span style={{ color: "#00ACF7" }}>RESET</span> PASSWORD
              </Typography>
              <form onSubmit={onSubmit}>
                <Box sx={{ my: 2 }}>
                  <InputLabel sx={{ fontWeight: "700" }}>
                    New Password
                  </InputLabel>
                  <div className="password__field__wrapper">
                    <TextField
                      placeholder="Enter new password"
                      type={passwordShow ? "text" : "password"}
                      fullWidth
                      className={classes.inputContainer}
                      value={password}
                      onChange={(e) => setPassword(e.target.value.trim())}
                    />
                    <button
                      type="button"
                      className="password__toggle_btn"
                      aria-label={
                        passwordShow ? "Hide password" : "Show password"
                      }
                      onClick={() => setPasswordShow(!passwordShow)}
                    >
                      {passwordShow ? (
                        <IoEye size={22} />
                      ) : (
                        <IoEyeOff size={22} />
                      )}
                    </button>
                  </div>
                </Box>
                <Box sx={{ my: 2 }}>
                  <InputLabel sx={{ fontWeight: "700" }}>
                    Confirm Password
                  </InputLabel>
                  <div className="password__field__wrapper">
                    <TextField
                      placeholder="Confirm password"
                      type={confirmPasswordShow ? "text" : "password"}
                      fullWidth
                      className={classes.inputContainer}
                      value={confirmPassword}
                      onChange={(e) =>
                        setConfirmPassword(e.target.value.trim())
                      }
                    />
                    <button
                      type="button"
                      className="password__toggle_btn"
                      aria-label={
                        confirmPasswordShow ? "Hide password" : "Show password"
                      }
                      onClick={() =>
                        setConfirmPasswordShow(!confirmPasswordShow)
                      }
                    >
                      {confirmPasswordShow ? (
                        <IoEye size={22} />
                      ) : (
                        <IoEyeOff size={22} />
                      )}
                    </button>
                  </div>
                </Box>
                <Divider />
                <button
                  className="login_btn"
                  type="submit"
                  disabled={!!loading}
                >
                  {!loading ? (
                    "Reset Password"
                  ) : (
                    <Spinner size="sm" animation="border" />
                  )}
                </button>
              </form>
              {resendVisible && (
                <Box
                  sx={{ display: "flex", justifyContent: "flex-end", mt: 2 }}
                >
                  <button
                    className="login_btn"
                    type="button"
                    onClick={() => setForgotOpen(true)}
                    style={{ width: 220 }}
                  >
                    Resend reset email
                  </button>
                </Box>
              )}
              <ReactModal
                open={forgotOpen}
                setOpen={setForgotOpen}
                title="Resend Reset Email"
                size={500}
              >
                <form onSubmit={handleForgotSubmit}>
                  <Box sx={{ my: 1 }}>
                    <InputLabel sx={{ fontWeight: 700 }}>Email</InputLabel>
                    <TextField
                      placeholder="Enter your email"
                      fullWidth
                      value={forgotEmail}
                      onChange={(e) => setForgotEmail(e.target.value)}
                    />
                  </Box>
                  <Box
                    sx={{ display: "flex", justifyContent: "flex-end", mt: 2 }}
                  >
                    <button
                      className="login_btn"
                      type="submit"
                      disabled={!!forgotState?.loading}
                      style={{ width: 180 }}
                    >
                      {!forgotState?.loading ? (
                        "Send Email"
                      ) : (
                        <Spinner size="sm" animation="border" />
                      )}
                    </button>
                  </Box>
                </form>
              </ReactModal>
            </Box>
          </Paper>
        </Grid>
      </Grid>
    </Box>
  );
};

export default ResetPassword;
